/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FirmwareType,
    FirmwareTypeFromJSON,
    FirmwareTypeFromJSONTyped,
    FirmwareTypeToJSON,
} from './FirmwareType';

/**
 * 
 * @export
 * @interface ReportForStbGroupsResponseElements
 */
export interface ReportForStbGroupsResponseElements {
    /**
     * 
     * @type {string}
     * @memberof ReportForStbGroupsResponseElements
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForStbGroupsResponseElements
     */
    name: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForStbGroupsResponseElements
     */
    size: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForStbGroupsResponseElements
     */
    loaderVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForStbGroupsResponseElements
     */
    firmwareVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForStbGroupsResponseElements
     */
    uiVersion: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForStbGroupsResponseElements
     */
    nbLoaderSuccessCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForStbGroupsResponseElements
     */
    nbFirmwareSuccessCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForStbGroupsResponseElements
     */
    nbUiSuccessCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForStbGroupsResponseElements
     */
    nbConnectedWithinLast24H: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForStbGroupsResponseElements
     */
    nbConnectionFailureCountLast1M: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForStbGroupsResponseElements
     */
    nbConnectionFailureCountLast3M: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForStbGroupsResponseElements
     */
    nbConnectionFailureCountLast6M: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForStbGroupsResponseElements
     */
    quota: number | null;
    /**
     * 
     * @type {FirmwareType}
     * @memberof ReportForStbGroupsResponseElements
     */
    quotaFirmwareType: FirmwareType;
}

export function ReportForStbGroupsResponseElementsFromJSON(json: any): ReportForStbGroupsResponseElements {
    return ReportForStbGroupsResponseElementsFromJSONTyped(json, false);
}

export function ReportForStbGroupsResponseElementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForStbGroupsResponseElements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'size': json['size'],
        'loaderVersion': json['loaderVersion'],
        'firmwareVersion': json['firmwareVersion'],
        'uiVersion': json['uiVersion'],
        'nbLoaderSuccessCount': json['nbLoaderSuccessCount'],
        'nbFirmwareSuccessCount': json['nbFirmwareSuccessCount'],
        'nbUiSuccessCount': json['nbUiSuccessCount'],
        'nbConnectedWithinLast24H': json['nbConnectedWithinLast24H'],
        'nbConnectionFailureCountLast1M': json['nbConnectionFailureCountLast1M'],
        'nbConnectionFailureCountLast3M': json['nbConnectionFailureCountLast3M'],
        'nbConnectionFailureCountLast6M': json['nbConnectionFailureCountLast6M'],
        'quota': json['quota'],
        'quotaFirmwareType': FirmwareTypeFromJSON(json['quotaFirmwareType']),
    };
}

export function ReportForStbGroupsResponseElementsToJSON(value?: ReportForStbGroupsResponseElements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'size': value.size,
        'loaderVersion': value.loaderVersion,
        'firmwareVersion': value.firmwareVersion,
        'uiVersion': value.uiVersion,
        'nbLoaderSuccessCount': value.nbLoaderSuccessCount,
        'nbFirmwareSuccessCount': value.nbFirmwareSuccessCount,
        'nbUiSuccessCount': value.nbUiSuccessCount,
        'nbConnectedWithinLast24H': value.nbConnectedWithinLast24H,
        'nbConnectionFailureCountLast1M': value.nbConnectionFailureCountLast1M,
        'nbConnectionFailureCountLast3M': value.nbConnectionFailureCountLast3M,
        'nbConnectionFailureCountLast6M': value.nbConnectionFailureCountLast6M,
        'quota': value.quota,
        'quotaFirmwareType': FirmwareTypeToJSON(value.quotaFirmwareType),
    };
}

